module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/store_images/5@2x_7e100eff16b1e5d3939539a7c949d179.png";